import useMediaQuery from '@mui/material/useMediaQuery';
import { AppTheme } from './../theme/model';
import { MOBILE_BREAKPOINT_THRESHOLD } from './../theme/const';

export const useIsMobile = (): boolean => {
  const isMobile = useMediaQuery((theme: AppTheme) => theme.breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD));

  return isMobile;
};
